const PageTitle = ({children}) => {
    return (
        <>
            {children}
        </>
    )
}

export default PageTitle
